import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import FieldOptionModel from "../../models/field-option";

export default class FieldOptionRepository extends BaseRepository {
  static modelClass = FieldOptionModel;
  modelName = "field-option";
}
